export enum WorkflowType {
  CUSTOM = 'CUSTOM',
  APPLICATION = 'APPLICATION',
  GENERAL = 'GENERAL',
  DEVICE = "DEVICE"
}
